
import './App.css';
import Carousel from './components/Carousel/Carousel';
import HeroSlider from './components/HeroSlider/HeroSlider';
import Hiring from './components/Home/Hiring/Hiring';

import CustomCursor from './components/HomeComponent/CustomCursor/CustomCursor';
import Navbar from './components/Navbar/Navbar';
import { Routes, Route } from 'react-router-dom';
import Lenis from '@studio-freight/lenis';
import { useEffect } from 'react';
import Home from './components/Home/Home';
import DigiSavvyFooter from './components/Footer/DigiSavvyFooter';
import Service from './components/Service/Service';
import { BlogDetails } from './components/Blog/BlogDetails';
import { DisplayBlog } from './components/Blog/DisplayBlog';
import PrivateRoute from './components/PrivateRoute/PrivateRoute';
import { BlogUpload } from './components/Blog/BlogUpload';
import Login from './components/User/Login';
import Register from './components/User/Register';
import ContactUs from './components/ContactUs/ContactUs';
import ContactUsData from './components/ContactUs/ContactUsData';
import AdminApplications from './components/Home/Hiring/AdminApplications';
import AdminDashboard from './components/AdminDashboard/AdminDashboard';
import UnauthorizedPage from './components/HomeComponent/UnauthorizedPage';
import WhatsAppButton from './components/WhatsAppButton/WhatsAppButton';
import Clients from './components/Cleints/Clients';
function App() {

  useEffect(() => {
    const lenis = new Lenis({
      duration: 0.2,
      easing: (t) => t, 
      smooth: true, 
      lerp: 0.05,
      wheelMultiplier: 0.4,
    });

    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <Navbar/>
    <CustomCursor />
      <Routes>
      <Route path="/" element={<Home/>} />
      <Route path="/service" element={<Service/>} />
      <Route path="/blog" element={<DisplayBlog />} />
      <Route path="/blog/:blogId" element={<BlogDetails />} />
      <Route exact path="/login" element={<Login/>} />
      
      <Route exact path="/Contact" element={<ContactUs/>} />
      <Route exact path="/Cleints" element={<Clients/>} />

      <Route exact path="/unauthorized" element={<UnauthorizedPage/>} />



      <Route path="/upload-blog" element={<PrivateRoute>{<BlogUpload/>} </PrivateRoute>}/>
      <Route path="/contactus-data" element={<PrivateRoute>{<ContactUsData/>} </PrivateRoute>}/>
      <Route path="/hiring-data" element={<PrivateRoute>{<AdminApplications/>} </PrivateRoute>}/>
      <Route path="/dashboard" element={<PrivateRoute>{<AdminDashboard/>} </PrivateRoute>}/>
            <Route path="/register" element={<PrivateRoute>{<Register/>} </PrivateRoute>}/>



      </Routes>
      <WhatsAppButton
        phoneNumber="+919818825449" 
        message="Hello, I would like to know more about your services." 
      />
      <DigiSavvyFooter/>
    </div>
  );
}

export default App;
